import { gql } from '@apollo/client';

export default gql`
query GetInstrument($IdInstrumento: ID!) {
  Instrument(IdInstrumento: $IdInstrumento) {
    IdInstrumento
    Instrumento
  }
}
`;